import { Component, OnInit, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { first } from 'rxjs/operators'
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { FeedbackService } from 'src/app/core/helpers/feedback.service';
import { TranslateService } from '@ngx-translate/core';
import { GaService } from 'src/app/core/helpers/ga.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

declare var $: any;

@Component({
    selector: 'loyaltic-feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss'],
    standalone: false
})
export class FeedbackComponent implements OnInit {

  contactForm: UntypedFormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private router: Router,
    private contactService: FeedbackService,
    @Inject('ImagePath') public ImagePath,
    public translate: TranslateService,
    public gaService: GaService,
  ) { }

  ngOnInit() {
    this.contactForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(100)]],
      email: ['', [Validators.required, Validators.email]],
      subject: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(1000)]],
      message: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(1000)]]
    });
  }

  get f() { return this.contactForm.controls; }

  onSubmit() {
    this.submitted = true;
    if (this.contactForm.invalid) {
      return;
    }
   
    this.loading = true;

    this.contactService.sendMessage(this.f.name.value, this.f.email.value, this.f.subject.value, this.f.message.value).pipe(first())
      .subscribe(data => {
        // this.gtmService.pushTag({ event: 'feed-back', status: 'Success' });
        this.gaService.emitEvent('feedback submit', 'feedback');
        this.contactForm.reset();
        this.loading = false;
        this.contactForm.reset();
        this.contactForm.clearValidators();
        this.router.navigate(['/feedback/success']);
      },
        error => {
          this.loading = false;
          this.router.navigate(['/feedback/success'], { queryParams: { status: 'failure' } });
        });
  }

}
